// Function to check if the clicked element is a descendant of a given element
export const isDescendant = (parent: any, child: any) => {
  let node = child;
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};
